import React, { useState } from "react";
// import { search } from "../../../../../express-netlify/express/routes/auth";
import logo from "../../data/images/Loading-Img.gif";
import SearchHighlighter from "./searchHighlighter";

import { searchQuery } from "../../data/data";

const Search = () => {
  const [searchRes, SetSearchRes] = useState([]);
  const [query, setquery] = useState("");
  const [searchingState, setsearchingState] = useState(false);

  const handleOnInputChange = (e) => {
    let q = e.target.value;
    console.log("event", q);
    // console.log("evented...", q);
    setquery(q);
    if ((e.charCode == 13) & (!e.target.value == "")) {
      submitQuery();
    }
    if (e.target.value == "") {
      SetSearchRes([]);
    }
  };

  const submitQuery = () => {
    setsearchingState(true);
    searchQuery("vinfinitysailor@gmail.com", query, "local-tocan").then(
      (query_res) => {
        console.log("search Q ==> ", query_res);
        query_res.length === 0 ? SetSearchRes([]) : SetSearchRes(query_res);
        setsearchingState(false);
      }
    );
  };

  return (
    <div className="extra-search">
      <div class="input-group">
        <div class="form-outline">
          <input
            type="search"
            id="form1"
            class="form-control"
            value={query}
            id="search-input"
            placeholder=""
            onKeyPress={handleOnInputChange}
            onChange={handleOnInputChange}
          />
          <label class="form-label" for="form1">
            Search in Docs-io
          </label>
        </div>
        <button type="button" class="btn btn-primary" onClick={submitQuery}>
          <i class="fas fa-search"></i>
        </button>
      </div>
      <div className="wrapper-search-result">
        {searchingState ? (
          <div style={{ display: "inline" }}>
            <img className="loading-img-micro " alt="topic-wait" src={logo} />
          </div>
        ) : searchRes.length === 0 ? (
          console.log("no data Found For same")
        ) : (
          <SearchHighlighter data={{"srchRes":searchRes,"query" : query}}/>
          )
        }
      </div>
    </div>
  );
};

export default Search;
